module.exports = __webpack_public_path__ + "img/Help.66b88e9.webp";